<template>
  <v-tabs
    class="tabs"
    v-bind:value="value"
    v-on:change="emitInput"
    background-color="transparent"
    show-arrows
  >
    <v-tabs-slider color="#0389e0" />
    <v-tab
      v-for="(item, itemIndex) in items"
      v-bind:key="itemIndex"
      v-bind:class="tabClass"
      class="tabs__item"
    >
      <slot v-bind="{ item, itemIndex }" />
    </v-tab>
    <slot name="after-items" />
  </v-tabs>
</template>

<script>

/**
 * @description Вкладки.
 * @type {Vue}
 */
export default {
  name: 'TheTabs',
  methods: {
    emitInput(index) {
      this.$emit('input', index);
    },
  },
  props: {
    /**
     * @description Индекс показываемой вкладки.
     * @type {?Number}
     */
    value: { default: () => null, type: [Number, Object] },
    /**
     * @description Элементы.
     * @type {Object[]}
     */
    items: { required: true, type: Array },
    tabClass: { default: '', type: String },
  },
};
</script>

<style lang="scss" scoped>
  .tabs {
    ::v-deep .v-slide-group__content {
      align-items: center;
    }
    &__item {
      column-gap: 10px;
    }
  }
</style>
